import { render, staticRenderFns } from "./listaPreventivi.html?vue&type=template&id=0f62d9a2&scoped=true&"
import script from "./ListaPreventivi.vue?vue&type=script&lang=js&"
export * from "./ListaPreventivi.vue?vue&type=script&lang=js&"
import style0 from "../../assets/styles/preventivo.css?vue&type=style&index=0&id=0f62d9a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f62d9a2",
  null
  
)

export default component.exports